






import Vue from 'vue'
import { QrcodeStream } from 'vue-qrcode-reader'
import { mutations } from '@/state'

export default Vue.extend({
  name: 'QRCameraScanner.vue',
  components: { QrcodeStream },
  props: {
    height: String,
    width: String
  },
  methods: {
    onDecode (result: string) {
      this.$emit('result', result)
    },
    paintOutline (detectedCodes: any, ctx: any) {
      for (const detectedCode of detectedCodes) {
        const [firstPoint, ...otherPoints] = detectedCode.cornerPoints

        ctx.strokeStyle = 'red'

        ctx.beginPath()
        ctx.moveTo(firstPoint.x, firstPoint.y)
        for (const {
          x,
          y
        } of otherPoints) {
          ctx.lineTo(x, y)
        }
        ctx.lineTo(firstPoint.x, firstPoint.y)
        ctx.closePath()
        ctx.stroke()
      }
    },
    async onInit (promise: any) {
      try {
        await promise
      } catch (error) {
        switch (error.name) {
          case 'NotAllowedError':
            mutations.setSnackbar('error', this.t({ s: 'camera.errorPermission', component: 'general' }))
            break
          case 'NotFoundError':
            mutations.setSnackbar('error', this.t({ s: 'camera.errorNoCamera', component: 'general' }))
            break
          case 'NotSupportedError':
            mutations.setSnackbar('error', this.t({ s: 'camera.errorNoHTTPS', component: 'general' }))
            break
          case 'NotReadableError':
            mutations.setSnackbar('error', this.t({ s: 'camera.errorAlreadyInUse', component: 'general' }))
            break
          case 'OverconstrainedError':
            mutations.setSnackbar('error', this.t({ s: 'camera.errorNotSuitable', component: 'general' }))
            break
          case 'StreamApiNotSupportedError':
            mutations.setSnackbar('error', this.t({ s: 'camera.errorNotSupported', component: 'general' }))
            break
        }
      }
    }
  }
})
